import { getDateStringVN } from "../../utils/DateTimeUtils";
import { tienFormat } from "../../utils/NumberUtils";
import { globalDexieDb } from "../DexiedbLib";
import { IContact } from "../model/contact";
import { MessageReport } from "./totalReport";

export interface ITotalreportAll {
    contactId: number;
    contactName: string;
    nhanVe: MessageReport | null;
    chuyenDi: MessageReport | null;
}
export class TotalreportAllImpl implements ITotalreportAll {
    contactId: number = 0;
    contactName: string = "";
    nhanVe: MessageReport | null = null;
    chuyenDi: MessageReport | null = null;
    public getLaiLoTotal(): number {
        let totalLaiLo = 0;
        let laiLoNhan = 0;
        let laiLoChuyen = 0;
        if (this.nhanVe != null)
            laiLoNhan = this.nhanVe.laiLoToanBo
        if (this.chuyenDi != null)
            laiLoChuyen = this.chuyenDi.laiLoToanBo;
        totalLaiLo = laiLoNhan + laiLoChuyen;
        return totalLaiLo
    }
    public async getSMSCongNo(): Promise<string> {
        let smsNhan = ''
        let smsChuyen = ''
        let sms = ''
        let ct: IContact | null = await this.getContact()
        if (!ct) {
            return sms
        }
        let desNhan = `Ngày ${this.getNgayVN()} ${this.getDesNhan(ct)} \n`
        let desChuyen = `Ngày ${this.getNgayVN()} ${this.getDesChuyen(ct)} \n`
        if (this.nhanVe) {
            smsNhan = desNhan + this.getSMSNhan(ct)
            sms = smsNhan
        }
        if (this.chuyenDi)
            smsChuyen = desChuyen + this.getSMSChuyen(ct)
        if (smsChuyen != '')
            sms = smsNhan + '\n-\n' + smsChuyen + '\n-\n' + this.getDesLaiLoToanBo(ct)
        return sms
    }
    private getSMSNhan(ct: IContact): string {
        let smsNhan = ''
        let smsTrung = ''
        if (!this.nhanVe)
            return smsNhan;
        for (let group of this.nhanVe.children) {
            for (let lc of group.children) {
                const tmp = `${lc.loaiCuocId}:${lc.xac}=${tienFormat(lc.quaCo)}n`
                smsNhan += (smsNhan != '' ? '\n' : '') + tmp;
                if (lc.trung != 0) {
                    const tmpTrung = `${lc.loaiCuocId}:${lc.trung}=${tienFormat(lc.thuong)}n`
                    smsTrung += (smsTrung != '' ? '\n' : '') + tmpTrung
                }
            }
        }
        if (smsTrung != '')
            smsNhan = smsNhan + '\nTrúng:\n' + smsTrung
        smsNhan += '\n' + this.getDesLaiLoNhan(this.nhanVe, ct)
        return smsNhan;
    }
    private getSMSChuyen(ct: IContact): string {
        let smsChuyen = ''
        let smsTrung = ''
        if (!this.chuyenDi)
            return smsChuyen;
        for (let group of this.chuyenDi.children) {
            for (let lc of group.children) {
                const tmp = `${lc.loaiCuocId}:${lc.xac}=${tienFormat(lc.quaCo)}n`
                smsChuyen += (smsChuyen != '' ? '\n' : '') + tmp;
                if (lc.trung != 0) {
                    const tmpTrung = `${lc.loaiCuocId}:${lc.trung}=${tienFormat(lc.thuong)}n`
                    smsTrung += (smsTrung != '' ? '\n' : '') + tmpTrung
                }
            }
        }
        if (smsTrung != '')
            smsChuyen = smsChuyen + '\nTrúng:\n' + smsTrung
        smsChuyen += '\n' + this.getDesLaiLoNhan(this.chuyenDi, ct)
        return smsChuyen;
    }
    private getDesNhan(ct: IContact): string {
        let result = ''
        const ngoi1 = ct.ngoi1 == '' ? 'cty' : ct.ngoi1
        const ngoi2 = ct.ngoi2 == '' ? ct.name : ct.ngoi2
        result = `${ngoi2} chuyển cho ${ngoi1}`
        return result;
    }
    private getDesChuyen(ct: IContact): string {
        let result = ''
        const ngoi1 = ct.ngoi1 == '' ? 'cty' : ct.ngoi1
        const ngoi2 = ct.ngoi2 == '' ? ct.name : ct.ngoi2
        result = `${ngoi1} chuyển cho ${ngoi2}`
        return result;
    }
    private async getContact(): Promise<IContact | null> {
        let ret: IContact | null = null;
        const ct = await globalDexieDb.contacts.where("contactId").equals(this.contactId).first()
        if (ct)
            ret = ct
        return ret
    }
    private getDesLaiLoNhan(msg: MessageReport, ct: IContact): string {
        let result = ''
        const ngoi1 = ct.ngoi1 == '' ? 'cty' : ct.ngoi1
        const ngoi2 = ct.ngoi2 == '' ? ct.name : ct.ngoi2
        if (msg.laiLoToanBo > 0)
            result = `${ngoi2} bù cho ${ngoi1} ${tienFormat(msg.laiLoToanBo)}n`
        else if (msg.laiLoToanBo < 0)
            result = `${ngoi1} bù cho ${ngoi2} ${tienFormat(msg.laiLoToanBo)}n`
        return result;
    }
    private getDesLaiLoChuyen(msg: MessageReport, ct: IContact): string {
        let result = ''
        const ngoi1 = ct.ngoi1 == '' ? 'cty' : ct.ngoi1
        const ngoi2 = ct.ngoi2 == '' ? ct.name : ct.ngoi2
        if (msg.laiLoToanBo > 0)
            result = `${ngoi2} bù cho ${ngoi1} ${tienFormat(msg.laiLoToanBo)}n`
        else if (msg.laiLoToanBo < 0)
            result = `${ngoi1} bù cho ${ngoi2} ${tienFormat(msg.laiLoToanBo)}n`
        return result;
    }
    private getDesLaiLoToanBo(ct: IContact): string {
        let result = ''
        const ngoi1 = ct.ngoi1 == '' ? 'cty' : ct.ngoi1
        const ngoi2 = ct.ngoi2 == '' ? ct.name : ct.ngoi2
        if (this.nhanVe != null && this.chuyenDi != null) {
            const total = this.nhanVe.laiLoToanBo + this.chuyenDi.laiLoToanBo
            if (total > 0) {
                result = `Tổng cộng ${ngoi2} bù cho ${ngoi1} ${tienFormat(total)}`
            } else if (total < 0) {
                result = `Tổng cộng ${ngoi1} bù cho ${ngoi2} ${tienFormat(total)}`
            }
        }
        return result;
    }
    private getNgayVN(): string {
        let ngay = ''
        let ret = ''
        if (this.nhanVe)
            ngay = this.nhanVe.date
        else if (this.chuyenDi)
            ngay = this.chuyenDi.date
        ret = getDateStringVN(ngay);
        return ret;
    }
}